import {
  avatar14,
  img15,
  img16,
  img17,
  img18,
} from "../../_components/Imagepath";

export default {
  ExpenseData: [
    {
      id: 1,
      company: "Orn LLC",
      email: "orn@example.com",
      image: avatar14,
      amount: "$199.99",
      status: "Paid",
      category: "Marketing",
      date: "01 Aug 2023, 04:35 PM",
    },
    {
      id: 2,
      company: "Accent Technology",
      email: "accent@example.com",
      image: img15,
      amount: "$99.99",
      status: "Paid",
      category: "Software",
      date: "05 Aug 2023, 07:00 PM",
    },
    {
      id: 3,
      company: "Express Advertising",
      email: "express@example.com",
      image: img16,
      amount: "$300.00",
      status: "Paid",
      category: "Advertising",
      date: "13 Aug 2023, 06:35 PM",
    },
    {
      id: 4,
      company: "Lexicon Technologies",
      email: "lexicon@example.com",
      image: img17,
      amount: "$690.00",
      status: "Pending",
      category: "Software",
      date: "15 Aug 2022, 03:30 PM",
    },
    {
      id: 5,
      company: "Sumo Soft Limited",
      email: "sumo@example.com",
      image: img18,
      amount: "$99.99",
      status: "Pending",
      category: "Stationery",
      date: "16 Aug 2022, 05:15 PM",
    },
  ],
};
